import * as STD                            from '@emersya/mpa-std-lib';
import CM                from '@emersya/mpa-components-manager-lib';
import { InputButton }   from '@emersya/mpa-components-lib';

export interface IStandingCounterOptionTileComponentConfiguration extends InputButton.Configuration {
	SKU : string;
	component : string;
};

export class StandingCounterOptionTile extends InputButton.Component {
	static override getInputEventSubType() {
		const parentClass = (<(typeof CM.Component) []> <any> STD.object.getInheritanceChainFromClass(this))[ 1 ];
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Button');
		}
		return parentClass.type;
	};
};
export namespace NS {
	export const Component = StandingCounterOptionTile;
	export type Component = StandingCounterOptionTile;
	export type Configuration = IStandingCounterOptionTileComponentConfiguration;
}
;
import manifestXMLSource from './StandingCounterOptionTile.xml';
import './StandingCounterOptionTile.scss';

CM.declare({
	id :       'standing-counter-optionTile',
	type :     StandingCounterOptionTile,
	manifest : manifestXMLSource
});
